import { render } from "./CompactLayout.vue?vue&type=template&id=2d53fb9e&scoped=true&ts=true"
import script from "./CompactLayout.vue?vue&type=script&lang=ts"
export * from "./CompactLayout.vue?vue&type=script&lang=ts"

import "./CompactLayout.vue?vue&type=style&index=0&id=2d53fb9e&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d53fb9e"]])

export default __exports__